import { useQuery } from '@tanstack/react-query';
import { UpdateToEventBatchBootstrapView } from '@mark43/cad-api';
import useUpdateToEventResource from './use-update-to-event-resource';

export const useFederatedSearchBootstrap = ({
    queryId,
    queryResultId,
    eventId,
    enabled = true,
    onError,
}: {
    queryId?: string;
    queryResultId?: string;
    eventId?: number;
    enabled?: boolean;
    onError?: () => void;
}) => {
    const { getUpdateToEventBatchBootstrap } = useUpdateToEventResource();

    return useQuery<UpdateToEventBatchBootstrapView | undefined>(
        ['federated-search-bootstrap', queryId, queryResultId, eventId],
        async () => {
            if (!queryId || !queryResultId) {
                return undefined;
            }
            const result = await getUpdateToEventBatchBootstrap({
                eventId,
                queryResultIdentifiers: [{ queryId, queryResultId }],
            });
            return result.data?.data;
        },
        {
            enabled: enabled && !!(queryId && queryResultId),
            cacheTime: 0,
            staleTime: 0,
            retry: 2,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            onError: () => onError?.(),
        }
    );
};
